<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <!-- <v-card> -->
      <!-- <v-toolbar dark color="primary" dense>
        <v-toolbar-title>New Option</v-toolbar-title>
      </v-toolbar> -->
      <!-- <div> -->
        <v-card class="mb-12" flat>
          <v-row class="px-6">
            <v-col cols="12" md="4">
              <v-card-title class="px-0">Review Details</v-card-title>
              <form>
                <v-text-field
                  v-model="newOptionModel.name"
                  :error-messages="nameErrors"
                  :counter="100"
                  label="Name"
                  required
                  placeholder="Give this option a name"
                  @input="$v.newOptionModel.name.$touch()"
                  @blur="$v.newOptionModel.name.$touch()"
                ></v-text-field>
                <v-container fluid class="pa-0">
                  <v-card-subtitle class="px-0">Criteria Values</v-card-subtitle>
                  <v-list dense>
                    <v-list-item v-for="criteriaItem in scrapedCriteria" v-bind:key="criteriaItem.id">
                      <v-list-item-content class="mb-4">
                        <v-container fluid class="pa-0">
                        <v-sheet elevation="4" class="pa-2 mx-1" v-if="newOptionModel.criteriaValues[criteriaItem.id]">
                          <strong>{{ criteriaItem.name }}</strong>
                          <!-- Select field if there are value options -->
                          <div v-if="newOptionModel.criteriaValueOptions && newOptionModel.criteriaValueOptions[criteriaItem.id] && newOptionModel.criteriaValueOptions[criteriaItem.id].length > 0">
                            <div class="d-flex align-center">
                              <div class="info--text my-1">
                                Choose a value
                              </div>
                              <v-btn
                                v-if="newOptionModel.criteriaValueOptions[criteriaItem.id].length > defaultVisibleValueOptions && newOptionModel.criteriaValues[criteriaItem.id].sourceIndex < defaultVisibleValueOptions"
                                class="ml-2"
                                x-small
                                @click="showAllValuesMap[criteriaItem.id] = !showAllValuesMap[criteriaItem.id]"
                              >
                                {{ showAllValuesMap[criteriaItem.id] ? 'show less' : 'show more' }}
                              </v-btn>
                            </div>
                            <v-chip-group
                              mandatory
                              column
                              v-model="newOptionModel.criteriaValues[criteriaItem.id].value"
                              active-class="primary"
                            >
                              <v-chip @click="selectSourceValue(criteriaItem.id, criteriaValue, valueIndex)" class="source-value-chip" :title="criteriaValue.value" v-for="(criteriaValue, valueIndex) in getCriteriaValueOptions(criteriaItem.id)/*newOptionModel.criteriaValueOptions[criteriaItem.id]*/" :key="valueIndex" :value="criteriaValue.value">
                                {{ criteriaValue.value }}
                              </v-chip>
                            </v-chip-group>
                            <div class="subtitle-1 font-weight-bold secondary--text my-4" v-if="!criteriaItem.keywordOnly || !newOptionModel.criteriaValues[criteriaItem.id].sourceValue">
                              Can't see the correct value?
                            </div>
                          </div>
                          <div v-else class="info--text text-caption">
                            No matching values found
                          </div>
                          <!-- <v-text-field
                            class="mt-2"
                            v-if="newOptionModel.url && ( (!criteriaItem.keywordOnly && newOptionModel.criteriaValues[criteriaItem.id].userValue) || (criteriaItem.keywordOnly && newOptionModel.criteriaValues[criteriaItem.id].userValue && newOptionModel.criteriaValues[criteriaItem.id].userValue !== 'NO') )"
                            :label="`Did this site use another keyword to indicate ${criteriaItem.name}?`"
                            outlined
                            :dense="true"
                            v-model="newOptionModel.criteriaValues[criteriaItem.id].suggestedKeyword"
                            hide-details="auto"
                            placeholder="Help Decidedly learn by entering the keyword"
                          ></v-text-field> -->
                          <div v-if="newOptionModel.url && ( !criteriaItem.keywordOnly || ( criteriaItem.keywordOnly && !newOptionModel.criteriaValues[criteriaItem.id].sourceValue) )">
                            <v-text-field
                              class="mt-2"
                              :label="`Did this site use another keyword to indicate ${criteriaItem.name}?`"
                              outlined
                              :dense="true"
                              v-model="newOptionModel.criteriaValues[criteriaItem.id].suggestedKeyword"
                              hide-details="auto"
                              placeholder="Type the keyword this site did use to find the value"
                            ></v-text-field>
                            <v-btn
                              v-if="newOptionModel.criteriaValues[criteriaItem.id].suggestedKeyword"
                              small
                              color="success"
                              class="my-2"
                              @click="synonymScrape(criteriaItem.id)"
                              :loading="scraping"
                              :disabled="scraping"
                            >Fetch new values</v-btn>
                          </div>
                          <v-select
                            class="mt-2"
                            v-if="criteriaItem.keywordOnly && !newOptionModel.criteriaValues[criteriaItem.id].sourceValue"
                            v-model="newOptionModel.criteriaValues[criteriaItem.id].userValue"
                            outlined
                            :dense="true"
                            :items="booleanCriteriaValueOptions"
                            :placeholder="newOptionModel.criteriaValueOptions && newOptionModel.criteriaValueOptions[criteriaItem.id] && newOptionModel.criteriaValueOptions[criteriaItem.id].length > 0 ? 'Or, enter your own value' : 'Provide a value'"
                          ></v-select>
                          <v-text-field
                            v-if="!criteriaItem.keywordOnly"
                            single-line
                            class="mt-2"
                            outlined
                            :dense="true"
                            hide-details="auto"
                            v-model="newOptionModel.criteriaValues[criteriaItem.id].userValue"
                            :placeholder="newOptionModel.criteriaValueOptions && newOptionModel.criteriaValueOptions[criteriaItem.id] && newOptionModel.criteriaValueOptions[criteriaItem.id].length > 0 ? 'Or, enter your own value' : 'Provide a value'"
                          ></v-text-field>
                        </v-sheet>
                      </v-container>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-container>
              </form>
            </v-col>
            <v-col cols="12" md="8">
              <OptionReviewCard :option="newOptionModel" :imgUrl="newOptionModel.imgSrc" :imageOptions="scrapedImageOptions" :criteria="scrapedCriteria" :screenGrabId="screenGrabId" :screenShotReady.sync="screenShotReady">
                <template v-slot:leftActions>
                  <v-btn small @click="$v.$reset(); dialog = false;">Cancel</v-btn>
                  <v-btn
                    :disabled="scraping"
                    @click="imageScrape"
                    small
                  >
                    <v-icon>mdi-image-search</v-icon>
                    More Images
                  </v-btn>
                </template>
                <template v-slot:rightActions>
                  <v-btn
                    color="success"
                    :disabled="scraping || $v.newOptionModel.$invalid"
                    @click="approveValues"
                  >
                    Accept Values
                  </v-btn>
                </template>
              </OptionReviewCard>
            </v-col>
          </v-row>
        </v-card>
      <!-- </div> -->
    <!-- </v-card> -->
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

// Custom mixins
import guid from '@/mixins/DecidedlyGUID.js'

import { mapState, mapGetters } from 'vuex'
// Veux types
import * as DecisionTypes from '../store/types/decision'

import OptionReviewCard from '@/components/OptionReviewCard.vue'

export default {
  name: 'ReviewScrapedOptionDialog',
  mixins: [validationMixin, guid],
  components: {
    OptionReviewCard
  },
  validations: {
    newOptionModel: {
      name: { required, maxLength: maxLength(100) }
    },
    /*customCriteriaName: {
      maxLength: maxLength(60),
      isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (!value || value === '') return true

        let existingIndex = -1
        if (this.editCriteriaList) {
          existingIndex = this.editCriteriaList.findIndex(item => item.name.toLowerCase() === value.toLowerCase())
        }
        return existingIndex < 0
      }
    }*/
  },
  props: {
    value: Boolean,
    optionModel: Object,
    // decisionId: String,
    // decisionTaxon: String,
    // decisionCriteria: Object
  },
  mounted: function () {
    this.resetDialog()
  },
  computed: {
    ...mapState({
      decisionId: state => state.decision.decisionId,
      decisionTaxon: state => state.decision.currentTaxon
    }),
    ...mapGetters('decision',{
      criteriaList: 'criteriaList'
    }),
    dialog: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    scrapedCriteria () {
      // return this.criteriaList.filter(criteriaItem => !criteriaItem.ignoreInScrape)
      let res = []
      if (this.optionModel && this.optionModel.criteriaValueOptions) {
        const scrapedCriteriaIds = Object.keys(this.optionModel.criteriaValueOptions)
        res = this.criteriaList.filter(criteriaItem => { return scrapedCriteriaIds.includes(criteriaItem.id)})
        // console.log(`Returning scraped list from options = ${JSON.stringify(this.optionModel.criteriaValueOptions)}`)
      }
      return res
    },
    scrapedImageOptions () {
      let res = []
      if (this.optionModel && this.optionModel.scrapeResult.imageOptions && this.optionModel.scrapeResult.imageOptions.length > 0) {
        res = this.optionModel.scrapeResult.imageOptions.map((nextImageOption) => {
          return nextImageOption.url
        })
      }
      return res
    },
    nameErrors () {
      const errors = []
      if (!this.$v.newOptionModel.name.$dirty) return errors
      !this.$v.newOptionModel.name.maxLength && errors.push('Name must be at most 100 characters long')
      !this.$v.newOptionModel.name.required && errors.push('Name is required.')
      return errors
    },
    scraping () {
      return this.optionModel && this.optionModel.scrapeState === Constants.SCRAPE_STATES.scraping
    },
    scrapingFinished () {
      return this.optionModel && this.optionModel.scrapeState === Constants.SCRAPE_STATES.scraped
    }
  },
  data () {
    return {
      // scraping: false,
      // checkScrapeSynonymFinishedInterval: null,
      scrapingCriteriaId: null,
      newOptionModel: {name: '', imgSrc: '', criteriaValues: {}, criteriaValueOptions: {}},
      screenGrabId: null,
      screenShotReady: false,
      showAllValuesMap: {},
      defaultVisibleValueOptions: 3,
      // scrapedImageOptions: [],
      booleanCriteriaValueOptions: ['YES', 'NO']
    }
  },
  watch: {
    // whenever question changes, this function will run
    value: function (newValue) {

      if (newValue === true) {
        this.$v.$reset()
        this.resetDialog()
      }
    },
    scrapingFinished: function (newValue) {
      if (this.scrapingCriteriaId && newValue) {
        console.log(`Updating values for ${this.scrapingCriteriaId}`)
        // Update this.newOptionModel.criteriaValues[this.scrapingCriteriaId]
        this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId] = this.optionModel.criteriaValueOptions[this.scrapingCriteriaId]
        // Set the value to the first in the list
        if (this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId] && this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId].length > 0) {
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].sourceValue = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].value
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].learnContext = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].learnContext
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].sourceIndex = 0
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].selectorId = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].selectorId
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].selectorKey = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].selectorKey
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].pagePosition = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].position
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].keyword = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].keyword
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].filteredKeywordFromValue = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].filteredKeywordFromValue
          this.newOptionModel.criteriaValues[this.scrapingCriteriaId].domSelector = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].domSelector
        }
      }
    }
  },
  methods: {
    resetDialog: function() {
      this.$v.$reset()
      // if (!this.newOptionModel.id) {
      //   this.newOptionModel.criteriaValues = {}
      //   this.newOptionModel.criteriaValueOptions = {}
      // }
      // this.newOptionModel = {id: this.genGUID(), name: '', criteriaValues: {}, criteriaValueOptions: {}}
      this.newOptionModel = {name: '', imgSrc: '', criteriaValues: {}, criteriaValueOptions: {}}
      this.screenGrabId = null
      this.screenShotReady = false
      // this.newOptionStep = 2
      this.syncNewOptionModelWithDecisionCriteria()
      this.buildScrapeResult()
    },
    /*dialogStateChanged: function (dialogOpening) {
      this.$v.$reset()
      if (!dialogOpening) {
        // Reset the dialog
        this.newOptionModel = {id: this.genGUID(), name: '', criteriaValues: {}, criteriaValueOptions: {}}
        this.syncNewOptionModelWithDecisionCriteria()

        this.newOptionStep = 1
      }
    },*/
    getCriteriaValueOptions: function (criteriaId) {
      let res = []
      if (this.showAllValuesMap[criteriaId]) {
        res = this.newOptionModel.criteriaValueOptions[criteriaId]
      } else {
        res = this.newOptionModel.criteriaValueOptions[criteriaId].slice(0, this.defaultVisibleValueOptions)
      }
      return res
    },
    selectSourceValue: function (criteriaId, criteriaValue, valueIndex) {
      this.newOptionModel.criteriaValues[criteriaId].sourceValue = criteriaValue.value
      this.newOptionModel.criteriaValues[criteriaId].learnContext = criteriaValue.learnContext
      this.newOptionModel.criteriaValues[criteriaId].selectorId = criteriaValue.selectorId
      this.newOptionModel.criteriaValues[criteriaId].selectorKey = criteriaValue.selectorKey
      this.newOptionModel.criteriaValues[criteriaId].pagePosition = criteriaValue.position
      this.newOptionModel.criteriaValues[criteriaId].sourceIndex = valueIndex
      this.newOptionModel.criteriaValues[criteriaId].keyword = criteriaValue.keyword
      this.newOptionModel.criteriaValues[criteriaId].filteredKeywordFromValue = criteriaValue.filteredKeywordFromValue
      this.newOptionModel.criteriaValues[criteriaId].domSelector = criteriaValue.domSelector
      // Show all value options if the selected option is outside the default visible range
      if( valueIndex >= this.defaultVisibleValueOptions) {
        this.showAllValuesMap[criteriaId] = true
      }
    },
    // saveOptionData: function () {
    //   if (this.newOptionModel.url) {
    //     this.approveExistingOption()
    //   } else {
    //     this.saveNewOption()
    //   }
    // },
    synonymScrape: async function (criteriaId) {
      // TODO call single value scrape with new keyword newOptionModel.criteriaValues[criteriaItem.id].suggestedKeyword, wait for it to finish / return to scraped state
      // newOptionModel.criteriaValues[criteriaItem.id].suggestedKeyword
      this.scrapingCriteriaId = criteriaId

      const userUID = firebase.auth().currentUser ? firebase.auth().currentUser.uid : null;
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postResetScrapeStateURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${this.optionModel.id}/criteria/scrape`
      const criteriaItemData = this.criteriaList.find(criteriaItem => criteriaItem.id === criteriaId)
      const criteriaItem = JSON.parse(JSON.stringify(criteriaItemData))
      // Update the item to use the suggested keyword as a name
      criteriaItem.name = this.newOptionModel.criteriaValues[criteriaId].suggestedKeyword
      const scrapeCriteriaList = [criteriaItem]

      const valuesOnlyScrapeBody = {
        url: encodeURI(this.optionModel.url),
        criteria: scrapeCriteriaList,
        valuesOnlyScrape: true
      }
      if (userUID) {
        valuesOnlyScrapeBody.uid = userUID // used to find user specific synonyms
      }

      // this.scraping = true
      // console.log(`Calling values only scrape with body ${JSON.stringify(valuesOnlyScrapeBody)}`)
      // const res = await axios.post(postResetScrapeStateURL, valuesOnlyScrapeBody, {
      axios.post(postResetScrapeStateURL, valuesOnlyScrapeBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: this.optionModel.id, scrapeState: Constants.SCRAPE_STATES.scraping})

      // if (res && res.status === 200 && !this.checkScrapeSynonymFinishedInterval) {
      //   this.startCheckScrapingFinished()
      // }
    },
    imageScrape: async function () {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const imageScrapeURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${this.optionModel.id}/image/scrape`

      const imageScrapeBody = {
        url: encodeURI(this.optionModel.url),
      }

      axios.post(imageScrapeURL, imageScrapeBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: this.optionModel.id, scrapeState: Constants.SCRAPE_STATES.scraping})
    },
    // startCheckScrapingFinished: function () {
    //   if (!this.scraping) {
    //     this.scraping = true
    //   }
    //   // repeat with the interval of 4 seconds
    //   this.checkScrapeSynonymFinishedInterval = setInterval(() => this.checkScrapeSynonymFinished(), 4000)
    // },
    // checkScrapeSynonymFinished: async function () {
    //   const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
    //   const checkOptionScrapeState = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${this.optionModel.id}/scrapestate`
    //
    //   // If not, check content has not changed
    //   const res = await axios.get(checkOptionScrapeState, {
    //     headers: {
    //       'Authorization': `Bearer ${token}`,
    //     }
    //   })
    //
    //   if (res && res.status === 200 && res.data && res.data.state === Constants.SCRAPE_STATES.scraped /* Scraped state */) {
    //     clearInterval(this.checkScrapeSynonymFinishedInterval)
    //
    //     // Load the latest option data
    //     const getOptionURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${this.optionModel.id}`
    //     // console.log(`Calling decision get optoin`)
    //     const optionRes = await axios.get(getOptionURL, {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${token}`,
    //       }
    //     })
    //     // console.log(`Status is approved, got option data`)
    //     if (optionRes && optionRes.status === 200 && optionRes.data && optionRes.data.status === 'success' ) {
    //       const latestOptionData = optionRes.data.optionData
    //       // Update local option model
    //       this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_DATA}`, {
    //         id: this.optionModel.id,
    //         name: latestOptionData.name,
    //         imgSrc: latestOptionData.imgSrc,
    //         sha256: latestOptionData.sha256,
    //         scrapeResult: latestOptionData.scrapeResult,
    //         criteriaValues: latestOptionData.criteriaValues,
    //         criteriaValueOptions: latestOptionData.criteriaValueOptions,
    //         scrapeState: latestOptionData.scrapeState
    //       })
    //
    //       // Update this.newOptionModel.criteriaValues[this.scrapingCriteriaId]
    //       this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId] = latestOptionData.criteriaValueOptions[this.scrapingCriteriaId]
    //       // Set the value to the first in the list
    //       if (this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId] && this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId].length > 0) {
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].sourceValue = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].value
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].learnContext = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].learnContext
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].sourceIndex = 0
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].selectorId = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].selectorId
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].selectorKey = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].selectorKey
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].pagePosition = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].position
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].keyword = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].keyword
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].filteredKeywordFromValue = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].filteredKeywordFromValue
    //         this.newOptionModel.criteriaValues[this.scrapingCriteriaId].domSelector = this.newOptionModel.criteriaValueOptions[this.scrapingCriteriaId][0].domSelector
    //       }
    //
    //     }
    //
    //     this.checkScrapeSynonymFinishedInterval = null
    //     // this.scraping = false
    //
    //     // Expand the scraped criteria values in the UI to show all values.
    //     // This is required in case the first options are still the same as with the previous name, we want the UI to show the new values which might be below the first N options.
    //     this.$set(this.showAllValuesMap, this.scrapingCriteriaId, true)
    //     this.scrapingCriteriaId = null
    //   }
    // },
    buildScrapeResult: function () {
      if (this.optionModel) {
        if (!this.optionModel.scrapeResult) {
          // We build a fake scrape result from existing option data.
          // This is to support single value scrapes which do not return a scrape result with titels, imgs etc to save time scraping just a new value.

          const rescrapeResult = {
            url: this.optionModel.url,
            title: this.optionModel.name,
            sha256: this.optionModel.sha256,
            imageOptions: [{url: this.optionModel.imgSrc, ranking: 1, position: 1}]
          }

          this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_RESULT}`, {
            id: this.optionModel.id,
            scrapeResult: rescrapeResult
          })

          // this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_DATA}`, {
          //   id: this.optionModel.id,
          //   name: this.optionModel.name,
          //   imgSrc: this.optionModel.imgSrc,
          //   sha256: this.optionModel.sha256,
          //   scrapeResult: rescrapeResult,
          //   criteriaValues: this.optionModel.criteriaValues,
          //   criteriaValueOptions: this.optionModel.criteriaValueOptions,
          //   scrapeState: this.optionModel.scrapeState
          // })

        }
        // else {
        // if (this.optionModel.scrapeResult) {
          this.newOptionModel.url = this.optionModel.url
          this.screenGrabId = this.optionModel.scrapeResult.screenGrabId
          // console.log(`Got a scrape response ${JSON.stringify(res.data)}`)
          // Set the title image and criteria value options found by the scrape
          this.newOptionModel.imgSrc = ''
          // if (this.optionModel.scrapeResult.imageOptions && this.optionModel.scrapeResult.imageOptions.length > 0) {
          //   this.$set(this.newOptionModel, 'imgSrc', this.optionModel.scrapeResult.imageOptions[0].url)
          //   this.scrapedImageOptions = this.optionModel.scrapeResult.imageOptions.map((nextImageOption) => {
          //     return nextImageOption.url
          //   })
          // }
          if (this.scrapedImageOptions.length > 0) {
            this.$set(this.newOptionModel, 'imgSrc', this.scrapedImageOptions[0])
          }

          // if (this.optionModel.imgSrc) {
          //   this.newOptionModel.imgSrc = this.optionModel.imgSrc
          // }

          if (this.optionModel.name) {
            this.newOptionModel.name = this.optionModel.name
          }

          // this.newOptionModel.name = this.newOptionModel.scrapeResult.title || ""
          this.newOptionModel.sha256 = this.optionModel.scrapeResult.sha256

          // Truncate name if it is longer than max name length (100)
          // if (this.newOptionModel.name.length > 100) {
          //   this.newOptionModel.name = this.newOptionModel.name.substring(0,100)
          // }

          // Add possible criteria values
          this.newOptionModel.criteriaValueOptions = {}
          const self = this
          Object.keys(this.optionModel.criteriaValueOptions).forEach((criteriaItemId) => {
            const criteriaItem = {id: criteriaItemId}
          // this.optionModel.scrapeResult.criteria.forEach((criteriaItem) => {
            self.newOptionModel.criteriaValueOptions[criteriaItem.id] = self.optionModel.criteriaValueOptions[criteriaItem.id]
            // Set the value to the first in the list
            // if (criteriaItem.values && criteriaItem.values.length > 0) {

            if (self.newOptionModel.criteriaValueOptions[criteriaItem.id] && self.newOptionModel.criteriaValueOptions[criteriaItem.id].length > 0) {
              self.newOptionModel.criteriaValues[criteriaItem.id].sourceValue = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].value
              self.newOptionModel.criteriaValues[criteriaItem.id].learnContext = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].learnContext
              self.newOptionModel.criteriaValues[criteriaItem.id].sourceIndex = 0
              // self.$set(self.newOptionModel.criteriaValues[criteriaItem.id], 'sourceIndex', 0)
              self.newOptionModel.criteriaValues[criteriaItem.id].selectorId = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].selectorId
              self.newOptionModel.criteriaValues[criteriaItem.id].selectorKey = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].selectorKey
              self.newOptionModel.criteriaValues[criteriaItem.id].pagePosition = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].position
              self.newOptionModel.criteriaValues[criteriaItem.id].keyword = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].keyword
              self.newOptionModel.criteriaValues[criteriaItem.id].filteredKeywordFromValue = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].filteredKeywordFromValue
              self.newOptionModel.criteriaValues[criteriaItem.id].domSelector = self.newOptionModel.criteriaValueOptions[criteriaItem.id][0].domSelector
            }
          })
        // }
      }
    },
    approveValues: function () {
      // this.optionModel.name = this.newOptionModel.name
      // this.optionModel.imgSrc = this.newOptionModel.imgSrc
      // this.optionModel.criteriaValues = this.newOptionModel.criteriaValues

      // Merge criteriaValues of newOptionModel with the optionModel as this UI also approves single value scrapes.
      // console.log(`Approve new values ${JSON.stringify(this.newOptionModel.criteriaValues)}`)

      const mergedValues = {...this.optionModel.criteriaValues, ...this.newOptionModel.criteriaValues} // Right most properties win, so new values are accepted but existing values are preserved
      // console.log(`Approve values and merging to ${JSON.stringify(mergedValues)}`)

      this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_APPROVED_DATA}`, {
        id: this.optionModel.id,
        name: this.newOptionModel.name,
        imgSrc: this.newOptionModel.imgSrc,
        criteriaValues: mergedValues
      })

      this.$emit('onApproved', this.optionModel)
      this.dialog = false
    },
    syncNewOptionModelWithDecisionCriteria: function () {
      this.showAllValuesMap = {}
      this.scrapedCriteria.forEach(item => {
      // this.criteriaList.forEach(item => {
        if (!this.newOptionModel.criteriaValues[item.id]) {
          this.$set(this.newOptionModel.criteriaValues, item.id, {sourceValue: null, userValue: null, sourceIndex: 0, suggestedKeyword: null})
        }
        this.$set(this.showAllValuesMap, item.id, false)
        //this.newOptionModel.criteriaValues[item.id] = {sourceValue: null, userValue: null}
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.first-step-wrapper {
  position: relative;
}

.scraping-progress-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
